/*eslint angular/window-service: "off"*/
import subdomains from '../../subdomains.json';

function getHostUrl(subdomain, env) {
  return `${subdomain}.${env !== 'prod' ? env + '.' : ''}collectivehealth.com`;
}

function isHost(env) {
  return subdomains.some((subdomain) =>
    window.location.host.includes(getHostUrl(subdomain, env))
  );
}

export function isProd() {
  return isHost('prod');
}

export function isLocal() {
  return isHost('local');
}

export function isTesting() {
  return isHost('testing');
}
